import { routes as publico } from '../screens/publico/routes';
import { routes as paciente } from '../screens/paciente/routes';
import { routes as profesional } from '../screens/profesional/routes';
import { routes as administracion } from '../screens/administracion/routes';
import type { Route } from './types';

export type { Route, RouteLayout, ScreenProps } from './types';

export const ROUTES: readonly Route[] = [...publico, ...paciente, ...profesional, ...administracion];
